<label class="a-switcher" [class.is-disabled]="isDisabled">
  <span>{{ label }}</span>
  <input type="checkbox" [checked]="control.value !== null ? control.value : selectedValue" (change)="onChange($event)">
  <i></i>
</label>